import UserAppearanceToggle from '@routes/settings/routes/user/userAppearanceToggle/UserAppearanceToggle'
import { Card } from '@routes/settings/routes/user/settings.user.route.styles'

const Appearance = () => (
    <Card>
        <UserAppearanceToggle />
    </Card>
)

export default Appearance
